module.exports = __webpack_public_path__ + "img/succ_icon.01084037.png";